const defaultTenantId = 'default';

export {defaultTenantId};



// WEBPACK FOOTER //
// ./src/modules/service/TenantService.js